var _rect, _rect2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAssignmentStats(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    rx: 8,
    fill: "#E9FBFB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4130_34903",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 14,
    width: 24,
    height: 24
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 14,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4130_34903)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 35C18.45 35 17.9792 34.8042 17.5875 34.4125C17.1958 34.0208 17 33.55 17 33V19C17 18.45 17.1958 17.9792 17.5875 17.5875C17.9792 17.1958 18.45 17 19 17H23.2C23.4167 16.4 23.7792 15.9167 24.2875 15.55C24.7958 15.1833 25.3667 15 26 15C26.6333 15 27.2042 15.1833 27.7125 15.55C28.2208 15.9167 28.5833 16.4 28.8 17H33C33.55 17 34.0208 17.1958 34.4125 17.5875C34.8042 17.9792 35 18.45 35 19V33C35 33.55 34.8042 34.0208 34.4125 34.4125C34.0208 34.8042 33.55 35 33 35H19ZM19 33H33V19H19V33ZM21 31H28V29H21V31ZM21 27H31V25H21V27ZM21 23H31V21H21V23ZM26 18.25C26.2167 18.25 26.3958 18.1792 26.5375 18.0375C26.6792 17.8958 26.75 17.7167 26.75 17.5C26.75 17.2833 26.6792 17.1042 26.5375 16.9625C26.3958 16.8208 26.2167 16.75 26 16.75C25.7833 16.75 25.6042 16.8208 25.4625 16.9625C25.3208 17.1042 25.25 17.2833 25.25 17.5C25.25 17.7167 25.3208 17.8958 25.4625 18.0375C25.6042 18.1792 25.7833 18.25 26 18.25Z",
    fill: "#008685"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssignmentStats);
export default __webpack_public_path__ + "static/media/assignment-stats.d3fa4da40a83003215db66817f067555.svg";
export { ForwardRef as ReactComponent };